"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteLabelCategory = exports.updateLabelCategory = exports.createLabelCategory = exports.getCategoryDescriptions = exports.reduceCategoryDescriptions = exports.getLabelCategories = exports.isSystemLabelCategory = exports.isCustomLabelCategory = void 0;
const tslib_1 = require("tslib");
const isCustomLabelCategory = (category) => 'description' in category;
exports.isCustomLabelCategory = isCustomLabelCategory;
const isSystemLabelCategory = (category) => 'isSystemCategory' in category;
exports.isSystemLabelCategory = isSystemLabelCategory;
const partialConfig = {
    restApiVersion: 'exp',
    serverWideRequest: false,
};
function getLabelCategories({ makeJsonRestApiRequest }) {
    var _a, _b;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const data = yield makeJsonRestApiRequest(Object.assign(Object.assign({}, partialConfig), { endpoint: 'labelCategories', httpMethod: 'GET' }));
        const labelCategories = (_b = (_a = data === null || data === void 0 ? void 0 : data.labelCategoryList) === null || _a === void 0 ? void 0 : _a.labelCategory) !== null && _b !== void 0 ? _b : [];
        return labelCategories.map(t => {
            if (t.description) {
                return ({ name: t.name, description: t.description });
            }
            else {
                return ({ name: t.name, isSystemCategory: true });
            }
        });
    });
}
exports.getLabelCategories = getLabelCategories;
function reduceCategoryDescriptions(categories) {
    return categories.reduce((acc, val) => {
        const description = 'description' in val ? val.description : undefined;
        if (description) {
            acc[val.name] = description;
        }
        return acc;
    }, {});
}
exports.reduceCategoryDescriptions = reduceCategoryDescriptions;
function getCategoryDescriptions({ makeJsonRestApiRequest }) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        return reduceCategoryDescriptions(yield getLabelCategories({ makeJsonRestApiRequest }));
    });
}
exports.getCategoryDescriptions = getCategoryDescriptions;
function createLabelCategory({ makeJsonRestApiRequest, category }) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const data = yield makeJsonRestApiRequest(Object.assign(Object.assign({}, partialConfig), { httpMethod: 'POST', endpoint: 'labelCategories' }), {
            labelCategory: {
                name: category.name,
                description: category.description,
            },
        });
        return {
            name: data.labelCategory.name,
            description: (_a = data.labelCategory.description) !== null && _a !== void 0 ? _a : '',
        };
    });
}
exports.createLabelCategory = createLabelCategory;
function updateLabelCategory({ makeJsonRestApiRequest, category, existingCategoryName }) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const data = yield makeJsonRestApiRequest(Object.assign(Object.assign({}, partialConfig), { endpoint: `labelCategories/${existingCategoryName}`, httpMethod: 'PUT' }), {
            labelCategory: {
                name: category.name,
                description: category.description,
            },
        });
        return {
            name: data.labelCategory.name,
            description: (_a = data.labelCategory.description) !== null && _a !== void 0 ? _a : '',
        };
    });
}
exports.updateLabelCategory = updateLabelCategory;
function deleteLabelCategory({ makeJsonRestApiRequest, existingCategoryName }) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const data = yield makeJsonRestApiRequest(Object.assign(Object.assign({}, partialConfig), { endpoint: `labelCategories/${existingCategoryName}`, httpMethod: 'DELETE' }));
        return {
            name: data.labelCategory.name,
            description: (_a = data.labelCategory.description) !== null && _a !== void 0 ? _a : '',
        };
    });
}
exports.deleteLabelCategory = deleteLabelCategory;
//# sourceMappingURL=labelCategories.js.map